var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHostBuddyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 2.39999L1 9.33333L2.06667 10.2L10 4.2L17.9333 10.2L19 9.33333L10 2.39999ZM3.6 10.0667L10 5.2L16.4 10.0667V15.2667H15.2L15.9333 17.0667L15.1333 17.4667L12.6 15.2667H3.6V10.0667ZM12.8 9.73332C12.8 10.1752 12.4418 10.5333 12 10.5333C11.5582 10.5333 11.2 10.1752 11.2 9.73332C11.2 9.2915 11.5582 8.93333 12 8.93333C12.4418 8.93333 12.8 9.2915 12.8 9.73332ZM8 10.5333C8.44182 10.5333 8.8 10.1752 8.8 9.73332C8.8 9.2915 8.44182 8.93333 8 8.93333C7.55817 8.93333 7.2 9.2915 7.2 9.73332C7.2 10.1752 7.55817 10.5333 8 10.5333ZM12.1517 11.9032C12.3803 11.9602 12.5225 12.1938 12.4298 12.4104C12.255 12.8189 11.98 13.1794 11.6273 13.4569C11.1622 13.8229 10.5886 14.0238 9.99681 14.0279C9.40502 14.032 8.82867 13.8392 8.35853 13.4797C8.00201 13.2072 7.72193 12.8505 7.54146 12.4446C7.44573 12.2292 7.58469 11.9937 7.81251 11.9335C8.04033 11.8733 8.26967 12.013 8.38132 12.2205C8.50258 12.4458 8.67096 12.6445 8.87682 12.8019C9.19651 13.0463 9.58844 13.1774 9.99085 13.1746C10.3933 13.1718 10.7833 13.0352 11.0996 12.7863C11.3032 12.6261 11.4688 12.4251 11.5869 12.1981C11.6957 11.989 11.923 11.8462 12.1517 11.9032Z",
    fill: "url(#paint0_linear_625_2239)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_625_2239",
    x1: 10,
    y1: 2.39999,
    x2: 10,
    y2: 17.4667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FA8ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#1155C0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHostBuddyIcon);
export default __webpack_public_path__ + "static/media/hostBuddy_icon.8edd9b95bba06d6b924f986ae19fb40e.svg";
export { ForwardRef as ReactComponent };